import React, { useState, useEffect } from "react";
import { auth, db } from "../../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { useNavigate, useLocation } from "react-router-dom";

const CompleteProfile = () => {
  const [userData, setUserData] = useState({});
  const [role, setRole] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const fetchUser = async () => {
      const user = auth.currentUser;
      if (!user) return;

      const userRef = doc(db, "users", user.uid);
      const userDoc = await getDoc(userRef);

      if (userDoc.exists()) {
        const data = userDoc.data();
        setUserData(data);
        setRole(data.role);
        setIsEditing(!data.profileComplete);
      } else {
        // New user
        const initialRole = location.state?.role || "user";
        const initialData = {
          uid: user.uid,
          username: location.state?.username || user.username || "",
          email: location.state?.email || user.email || "",
          contact: location.state?.phone || user.phoneNumber || "",
          role: initialRole,
          isActive: true,
          downloads: [],
        };
        setUserData(initialData);
        setRole(initialRole);
        setIsEditing(true);
      }

      setLoading(false);
    };

    fetchUser();
  }, [location.state]);

  const handleChange = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value });
  };

  const generateAccountId = (role) => {
    const prefix = role === "agent" ? "A" : "U";
    return prefix + Math.floor(100000 + Math.random() * 900000);
  };

  const handleSubmit = async () => {
    const user = auth.currentUser;
    const userRef = doc(db, "users", user.uid);

    const updatedData = {
      ...userData,
      profileComplete: true,
      isActive: true,
    };

    if (!userData.accountId) {
      updatedData.accountId = generateAccountId(role);
    }

    await setDoc(userRef, updatedData, { merge: true });
    setIsEditing(false);

    if (role === "agent") {
      navigate("/agent-dashboard");
    } else {
      navigate("/user-dashboard");
    }
  };

  if (loading) return <div className="container mt-5">Loading...</div>;

  return (
    <div className="container mt-5">
      <h3 className="mb-4">Complete Your Profile</h3>

      {isEditing ? (
        <>
          <input
            name="username"
            className="form-control mb-2"
            placeholder="Full Name"
            value={userData.username}
            onChange={handleChange}
          />
          <input
            name="contact"
            className="form-control mb-2"
            placeholder="Contact Number"
            value={userData.contact || ""}
            onChange={handleChange}
          />

          <input
            name="area"
            className="form-control mb-2"
            placeholder="Area"
            value={userData.area || ""}
            onChange={handleChange}
          />
          <input
            name="mandal"
            className="form-control mb-2"
            placeholder="Mandal"
            value={userData.mandal || ""}
            onChange={handleChange}
          />
          <input
            name="district"
            className="form-control mb-2"
            placeholder="District"
            value={userData.district || ""}
            onChange={handleChange}
          />
          <input
            name="state"
            className="form-control mb-2"
            placeholder="State"
            value={userData.state || ""}
            onChange={handleChange}
          />
          {role === "agent" && (
            <>
              <input
                name="name"
                className="form-control mb-2"
                placeholder="Full Name"
                value={userData.name || ""}
                onChange={handleChange}
              />

              <select
                name="printStyle"
                className="form-select mb-2"
                value={userData.printStyle || ""}
                onChange={handleChange}
              >
                <option value="">Select Print Style</option>
                <option value="selfPrinting">Self Printing</option>
                <option value="bulkOrder">Bulk Order</option>
              </select>
            </>
          )}
          <button className="btn btn-primary w-100" onClick={handleSubmit}>
            Save Profile
          </button>
        </>
      ) : (
        <div className="card shadow-sm p-4">
          <h4 className="mb-4 border-bottom pb-2">Profile Overview</h4>
          <div className="row">
            <div className="col-md-6 mb-3">
              <strong>Full Name:</strong>
              <div>{userData.username}</div>
            </div>
            <div className="col-md-6 mb-3">
              <strong>Area:</strong>
              <div>{userData.area}</div>
            </div>
            <div className="col-md-6 mb-3">
              <strong>Mandal:</strong>
              <div>{userData.mandal}</div>
            </div>
            <div className="col-md-6 mb-3">
              <strong>District:</strong>
              <div>{userData.district}</div>
            </div>
            <div className="col-md-6 mb-3">
              <strong>State:</strong>
              <div>{userData.state}</div>
            </div>
            <div className="col-md-6 mb-3">
              <strong>Mobile:</strong>
              <div>{userData.contact || userData.mobile}</div>
            </div>

            {role === "agent" && (
              <>
                <div className="col-md-6 mb-3">
                  <strong>Name:</strong>
                  <div>{userData.name}</div>
                </div>
                <div className="col-md-6 mb-3">
                  <strong>Credits:</strong>
                  <div>{userData.credits}</div>
                </div>
                <div className="col-md-6 mb-3">
                  <strong>Print Style:</strong>
                  <div>{userData.printStyle}</div>
                </div>
              </>
            )}
          </div>

          <div className="text-end">
            <button
              className="btn btn-outline-primary"
              onClick={() => setIsEditing(true)}
            >
              Edit Profile
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CompleteProfile;
